import { DocumentoDTO } from "./documento.dto";

export class EditalDTO {
    id: number;
    nomeEdital: string;
    periodoInicio: string;
    periodoFim: string;
    dataDistribuicao: string;
    bloquear: number;
    anexoEdital: String;
    nomeAnexo: String;
    documento: DocumentoDTO;
}